// extracted by mini-css-extract-plugin
export default {"wrapper":"PreferencesPane_wrapper__OLqz6"};